module.exports = __webpack_public_path__ + "static/logo-bdc804f6cf4546f782d02f70f40ac088.png";